/* eslint-disable react/no-danger */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { FormButton } from 'components/buttons/formButton';

export const FormDialog = ({
  isOpen, title, cancelButtonRef, onClose,
  children, buttons, onSubmit, small,
}) => {
  const renderForm = () => {
    return (
      <div className="mt-3 sm:mt-0 sm:text-left">
        <Dialog.Title as="h3" className="text-lg text-left leading-6 font-medium text-gray-900 mb-6">
          {title}
        </Dialog.Title>
        <div className="mt-2">
          {children}
        </div>
      </div>
    );
  };

  const renderButtons = () => {
    if (!buttons || buttons.length === 0) {
      return null;
    }

    return (
      <div className="mt-10 sm:mt-10 sm:flex sm:flex-row-reverse">
        {buttons.map((buttonData, ind) => {
          let customCss = '';

          if (buttonData.color === 'red') {
            customCss = 'border-transparent bg-red-600 text-white hover:bg-red-700 focus:ring-red-500';
          } else if (buttonData.color === 'blue') {
            customCss = 'border-transparent bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-500';
          } else if (buttonData.color === 'gray') {
            customCss = 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-indigo-500';
          }

          if (ind !== buttons.length - 1) {
            customCss += ' sm:ml-3';
          } else {
            customCss += ' sm:mt-0 mt-3';
          }

          if (buttonData.useFormButton) {
            return (
              <FormButton
                key={buttonData.text}
                disabled={buttonData.disabled}
                isLoading={buttonData.loading}
                noMargin={buttonData.noMargin}
                onClick={buttonData.type === 'submit' ? undefined : 'button'}
                text={buttonData.text}
              />
            );
          }

          return (
            <button
              key={buttonData.text}
              className={`w-full inline-flex justify-center rounded-md border shadow-sm px-4 py-2 
          text-base font-medium focus:outline-none focus:ring-2 
          focus:ring-offset-2 sm:w-auto sm:text-sm ${customCss}`}
          // eslint-disable-next-line react/button-has-type
              type={buttonData.type ? buttonData.type : 'button'}
              onClick={buttonData.onClick}
            >
              {buttonData.text}
            </button>
          );
        })}
      </div>
    );
  };

  const renderContent = () => {
    if (onSubmit) {
      return (
        <form onSubmit={onSubmit} action="#" method="POST">
          {renderForm()}
          {renderButtons()}
        </form>
      );
    }

    return (
      <>
        {renderForm()}
        {renderButtons()}
      </>
    );
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-50 inset-0 overflow-y-auto"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <div className="pt-4 px-4 pb-20 text-center block lg:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="inline-block align-middle h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className={`relative inline-block bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden
              shadow-xl transform transition-all sm:my-8 align-middle sm:p-6 w-full ${small ? 'md:w-4/6 lg:w-2/6' : 'lg:w-3/6'} `}
            >
              {renderContent()}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
